import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import reducer from './redux/reducer';

export const store = configureStore({
  reducer,
  middleware: [thunk, ...getDefaultMiddleware({ serializableCheck: false })]
});
